import realizaSelectors from 'store/sagas/selectors/realiza';

export default realizaSelectors('welfare', 'WELFARE.LANDING');
